import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useLocation} from 'react-router-dom';
import searchFilter from '../../../searchFilter';
import {RouterLinkButton} from '../../../components/button/button';


const NoImpulseFound = () => {
    const location = useLocation();

    return (
        <div className='padding-top-14rem padding-bottom-10rem mw768-padding-left-5rem mw768-padding-right-5rem'>
            <div className='text-xl color-gray-700 semibold text-align-center'>
                <FormattedMessage defaultMessage="We couldn't find your order"/>
            </div>
            <div className='text-lg color-gray-500 padding-bottom-1dot5rem text-align-center'>
                <FormattedMessage defaultMessage="Find out what's interesting"/>
            </div>
            <div className='text-align-center'>
                <RouterLinkButton {...{color: 'primary-gradient', size: 'xl', fluid: 'mobile', to: `/${searchFilter(location.search)}`}} >
                    <FormattedMessage defaultMessage='Return to main page'/>
                </RouterLinkButton>
            </div>
        </div>
    )
};

export default React.memo(NoImpulseFound);
